import { render, staticRenderFns } from "./SectionPromoMobileApp.vue?vue&type=template&id=41ef8695&"
import script from "./SectionPromoMobileApp.vue?vue&type=script&lang=js&"
export * from "./SectionPromoMobileApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports